import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fileEncoding: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.file-encoding',
		defaultMessage: 'File encoding',
		description: 'Heading for the field to specify the file encoding to be used during the import',
	},
	delimiter: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.delimiter',
		defaultMessage: 'Delimiter',
		description: 'Heading for the field to specify the delimiter to be used during the import',
	},
	advancedOptions: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.advanced-options',
		defaultMessage: 'Advanced file configuration options',
		description:
			'Heading for advanced options accordion to show fields to configure encoding, delimiter and date format',
	},
	advancedCsvSettingsNonFinal: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.advanced-csv-settings-non-final',
		defaultMessage: 'Advanced CSV settings',
		description:
			'New heading for advanced options accordion to show fields to configure encoding, delimiter and date format',
	},
	fileEncodingPopupDescription: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.file-encoding-popup-description',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'When you open or save a file, you can choose an encoding standard. File encoding is how text is stored and helps programs determine how to represent text so that it’s readable in different languages. It can also include numerical characters, alphabetical characters, and other symbols. UTF-8 is the most common file encoding language.',
		description:
			'Description for popup message shown to provide more information about the types of file encodings supported',
	},
	delimiterPopupHeading: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.delimiter-popup-heading',
		defaultMessage: 'Values separated by delimiters',
		description:
			'Heading for popup message shown to provide more information about the types of csv delimiters supported',
	},
	delimiterPopupDescription: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.delimiter-popup-description',
		defaultMessage:
			'Your columns can have multiple values and separated by commas (,) or pipes (|).',
		description:
			'Description for popup message shown to provide more information about the types of csv delimiters supported',
	},
	advancedOptionsDescription: {
		id: 'project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.advanced-options-description',
		defaultMessage: 'Advanced options for Import from CSV',
		description: 'Description Advanced options accordion',
	},
});
